//
// ReportAsset.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../TransportModel";
import "../media/particles/ReportAssetURL";
import "./Report";

var ReportAsset = createModule("transport::ReportAsset", ["commons::PropertyOwner","commons::BaseModel","transport::TransportModel"], EventDispatcher, [
    ,
    {
        isDownloadInProgress: 2,
        downloadSize: 4,
        lastAttemptTime: 9,
        lastContentKey: 7,
        localPath: 7,
        report: 1,
        numberOfDownloadAttempts: 4,
        downloadedAmount: 4,
        url: 1,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default ReportAsset;
